module.exports = __webpack_public_path__ + "img/emoticons.b3e9dae6.png";